exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-img {\n  height: 25em;\n  width: 21em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/news/view-news/view-news.component.scss
// module id = ../../../../../src/app/routes/restaurant/news/view-news/view-news.component.scss
// module chunks = main